import { useObservableValue } from '@noshiro/syncflow-preact-hooks';
import { createRouter } from '@noshiro/tiny-router-observable';
const { pathname$, queryParams$, back, push, redirect, removeListener } = createRouter();
export const usePathname = () => useObservableValue(pathname$);
export const useQueryParams = () => useObservableValue(queryParams$);
export { pathname$, queryParams$, back, push, redirect, removeListener };
